import styled from "styled-components";
import { FlexMixin, FontMixin } from "../../../../styles/common/mixins/helpers.styled.js";
import { BorderRadius } from "../../../../styles/common/mixins/logical.styled.js";
import toggleThemes from "./themes/index.js";
export const ToggleWrapper = styled.div.withConfig({
    displayName: "styled__ToggleWrapper",
    componentId: "sc-86246a2e-0"
})`
	${FlexMixin({
    align: 'center',
    justify: 'space-between'
})}
	--toggle-background-color-before: ${({ theme  })=>theme.colors.primary.lighter};
	--toggle-background-color-after: ${({ theme  })=>theme.colors.grays.lighter};
	--toggle-color-before: ${({ theme  })=>theme.colors.white.base};
	--toggle-color-after: ${({ theme  })=>theme.colors.grays.base};
	${({ theme  })=>toggleThemes[theme.id]?.ToggleWrapper?.()};
`;
export const ToggleLabel = styled.label.withConfig({
    displayName: "styled__ToggleLabel",
    componentId: "sc-86246a2e-1"
})`
	color: ${({ theme  })=>theme.colors.grays.darker};

	${({ $hasError , theme  })=>$hasError ? `color: ${theme.colors.status.error};` : ''}

	${FontMixin({
    size: 'medium',
    height: 'small',
    weight: 'regular'
})}
`;
export const ToggleInputWrapper = styled.div.withConfig({
    displayName: "styled__ToggleInputWrapper",
    componentId: "sc-86246a2e-2"
})`
	position: relative;
	width: 68px;
`;
export const InputInner = styled.div.withConfig({
    displayName: "styled__InputInner",
    componentId: "sc-86246a2e-3"
})`
	${FontMixin({
    size: 'small',
    height: 'larger',
    weight: 'light'
})}
	transition: margin 0.2s ease-in 0s;
	width: 200%;
	display: block;

	::before {
		content: '${(props)=>props.$yes}';
		background-color: var(--toggle-background-color-before);
		color: var(--toggle-color-before);
		padding: 0 0 0 10px;
		box-sizing: border-box;
		display: block;
		float: left;
		height: 30px;
		width: 50%;
		margin-left: -100%;
		transition: margin 0.2s ease-in 0s;
	}

	::after {
		content: '${(props)=>props.$no}';
		box-sizing: border-box;
		display: block;
		float: left;
		height: 30px;
		width: 50%;
		background-color: var(--toggle-background-color-after);
		color: var(--toggle-color-after);
		padding: 0 10px 0 0;
		text-align: right;
	}

	${({ theme  })=>toggleThemes[theme.id]?.InputInner?.()};
`;
export const ToggleInputLabel = styled.label.withConfig({
    displayName: "styled__ToggleInputLabel",
    componentId: "sc-86246a2e-4"
})`
	${BorderRadius({
    all: '24px'
})}
	cursor: pointer;
	display: block;
	overflow: hidden;
	width: 100%;
`;
export const CheckboxLabel = styled.div.withConfig({
    displayName: "styled__CheckboxLabel",
    componentId: "sc-86246a2e-5"
})`
	${BorderRadius({
    all: '24px'
})}
	cursor: pointer;
	display: block;
	overflow: hidden;
	width: 100%;
`;
export const ToogleSpan = styled.div.withConfig({
    displayName: "styled__ToogleSpan",
    componentId: "sc-86246a2e-6"
})`
	${BorderRadius({
    all: '50%'
})}
	background: ${({ theme  })=>theme.colors.white.base};
	bottom: 0;
	display: block;
	height: 20px;
	margin: 5px;
	position: absolute;
	right: 38px;
	top: 0;
	transition: all 0.3s ease-in 0s;
	width: 20px;
`;
export const ToggleInput = styled.input.withConfig({
    displayName: "styled__ToggleInput",
    componentId: "sc-86246a2e-7"
})`
	${BorderRadius({
    all: '4px'
})}
	background-color: ${({ theme  })=>theme.colors.white.base};
	border: none;
	cursor: pointer;
	height: 16px;
	margin-right: 8px;
	width: 16px;
	z-index: -1;
	display: none;

	:checked {
		+ ${ToggleInputLabel} ${InputInner}::before {
			margin-left: 0;
		}

		+ ${ToggleInputLabel} ${ToogleSpan} {
			right: 0;
		}
	}
`;

//# sourceMappingURL=styled.js.map